import Axios from '@/utils/axios'
import { EventSourcePolyfill } from 'event-source-polyfill'
import Cookies from 'js-cookie'
const URL = '/ambulatorio-digital'
const apiUrl = process.env.VUE_APP_API_URL

export default {
  buscaSalaAtendimentoClinico: () => Axios.get(`${URL}/atendimento-clinico`),
  enterOnQueue: idAtendimentoAmbulatorial =>
    Axios.post(`${URL}/atendimento-ambulatorial/enter-on-queue`, { idAtendimentoAmbulatorial }),
  queueStatus: idAtendimentoAmbulatorial => {
    const headers = { Authorization: `Bearer ${Cookies.get('ami_user_token') || ''}` }
    return new EventSourcePolyfill(
      `${apiUrl}${URL}/atendimento-ambulatorial/${idAtendimentoAmbulatorial}/queue-status`,
      {
        headers: headers
      }
    )
  },
  enterOnRoom: (idAtendimento, idMeetingRoom) => {
    return Axios.post(`${URL}/enter-on-room`, { idAtendimento, idMeetingRoom })
  },
  checkAppointmentStatus: idAtendimento => {
    const headers = { Authorization: `Bearer ${Cookies.get('ami_user_token') || ''}` }
    return new EventSourcePolyfill(
      `${apiUrl}/ambulatorio-digital/atendimento-ambulatorial/${idAtendimento}/room-status`,
      {
        headers: headers
      }
    )
  },
  saveAtendimento: data => Axios.post(`${URL}/atendimento-ambulatorial/save-atendimento`, { data }),
  getAgendamentos: () => Axios.get(`${URL}/agendamentos-ambulatoriais`),
  getAgendamento: idAtendimento => Axios.get(`${URL}/agendamentos-ambulatoriais/${idAtendimento}`),
  createAmbulatorio: ({ tipo, idHorario }) => Axios.post('/agendar-exame/ambulatorio-digital', { tipo, idHorario }),
  updateAmbulatorio: ({ tipo, idHorario, idAtendimento }) =>
    Axios.put(`/agendar-exame/ambulatorio-digital/${idAtendimento}`, { tipo, idHorario })
}
